import { Badge } from '../../../../components/Badge'
import { Card, CardProps } from '../../../../components/Card'
import { ImageProps } from '../../../../components/Image'
import { LinkProps } from '../../../../components/Link'
import { genderLabelMap, levelLabelMap } from '../../../../constants'
import { formatNumber } from '../../../../utils/formatNumber'
import { ProgramsFacilityCardProps } from '../../types'
import { ImageMapper, useImageMapper } from '../../utils/useImageMapper'

export const ProgramCard = (
  props: ProgramsFacilityCardProps['programs'][number] & {
    layout?: CardProps['layout']
    imageMapper?: ImageMapper
    priority?: boolean
    titleAs?: keyof HTMLElementTagNameMap
    href?: LinkProps['href']
    as?: LinkProps['as']
    external?: LinkProps['external']
    target?: LinkProps['target']
  },
) => {
  const {
    layout,
    imageMapper,
    name,
    duration,
    minimumPoint,
    activities,
    level,
    sexLimitation,
    titleAs,
    priority,
    href,
    as,
    external,
    target,
  } = props

  const programLink = {
    href,
    as,
    external,
    target,
  }

  const images = useImageMapper(props, imageMapper)
  const firstActivity = activities[0]
    ? typeof activities[0] === 'string'
      ? activities[0]
      : activities[0].name
    : null

  return (
    <Card layout={layout}>
      <Card.Image
        images={[images[0] as ImageProps]}
        {...programLink}
        priority={priority}
      />
      <Card.Content>
        <Card.Content.Heading
          variant="secondary"
          titleAs={titleAs}
          {...programLink}
        >
          {name}
        </Card.Content.Heading>

        <Card.Content.Body>
          {duration}min
          {minimumPoint ? ` / ${formatNumber(minimumPoint)}pt〜` : ''}
        </Card.Content.Body>

        <Card.Content.BadgeList mt={2}>
          {firstActivity && <Badge>{firstActivity}</Badge>}
          <Badge>{levelLabelMap[level]}</Badge>
          {sexLimitation !== 'none' && (
            <Badge variant={sexLimitation}>
              {genderLabelMap[sexLimitation]}
            </Badge>
          )}
        </Card.Content.BadgeList>
      </Card.Content>
    </Card>
  )
}
